<template>
    <div class="kyc-fields-area mb-20">

        <div class="disclaimer mb-30" v-if="showDisclaimer.length && !localkycView">
                <div class="flex align-center gap-10 mb-5">
                    <div class="req-warning"> <img src="@/assets/warning_.svg">Warning: </div> <span class="disclaimer-text">The following information is required to enable automatic notifications and review progress:</span>
                </div>
                <div class="warning-point"> {{ showDisclaimer.join(', ') }}</div>
        </div>

        <div class="flex full-width gap-30 mb-30" v-if="localCompanyData">
            <ChartComponent

                v-if="localCompanyData && localCompanyData.company_type == 'corporate'"
                class="flex justify-center align-center w-full">
            </ChartComponent>
        </div>

        

        <div class="flex full-width gap-30 mb-40" v-if="localCompanyData">
           
            <div class=" flex column gap-30 flex-1" >
                <div class="p-20 bg-white">
                    <h3 class='mt-0' v-if="localCompanyData.company_type == 'corporate'"> Company Information </h3>
                    <h3 class='mt-0' v-else> Account Holder Information </h3>
                    <!-- <button 
                        @click="verifyReport"
                        class='mb-20' v-if="PermissionChecker.verifyReport() && !reviewMode">
                        Verify report
                    </button> -->
                    <div class="flex gap-30 full-width">
                        <div class="flex column flex-1">
                            <InpComponent
                                v-if="localCompanyData.company_type == 'corporate'"
                                class="country-select flex-1"
                                label="Company Type"
                                type="options"
                                :disabled="!canEditInputs"
                                :options="[{value: 'local', text: 'Onshore'}, {value: 'abroad', text: 'Offshore'}]"
                                placeholder="Company Type"
                                :key_ref="'location_type'"
                                :value="localCompanyData?.location_type.new_value || localCompanyData?.location_type.value"
                                @inputChange="inputChangeFunc"
                            />
                            <InpComponent
                                v-else
                                class="country-select flex-1"
                                label="Client Type"company_id
                                type="options"
                                :disabled="!canEditInputs"
                                :options="[
                                    {value: 'bank', text: 'Bank'}, 
                                    {value: 'credit_union', text: 'Credit Union'},
                                    {value: 'pention', text: 'Pension'},
                                    {value: 'insurance', text: 'Insurance'},
                                    {value: 'player', text: 'Player'}
                                ]"
                                placeholder="Company Type"
                                :key_ref="'account_holder_type'"
                                :value="localCompanyData?.account_holder_type.new_value || localCompanyData?.account_holder_type.value"
                                @inputChange="inputChangeFunc"
                            />
                            <InpComponent
                                v-for="(accountNumber, index) in accountNumbers"
                                :key="`account_holder_number_${accountNumber._id}`"
                                :disabled="!canEditInputs"
                                type="text" 
                                :key_ref="`account_number|${accountNumber._id}`"
                                :value="accountNumber.account_number.new_value != undefined ? accountNumber.account_number.new_value : accountNumber.account_number.value" 
                                @inputChange="inputChangeFunc"
                                :label="getLabel"
                            />
                            <div @click="addAccountNumber()"
                                v-if="!reviewMode"
                                class="add-section flex align-center w-content">
                                <img src="@/assets/icon-addlink.svg"> Add Account Number
                            </div>
                            <InpComponent
                                v-if="localCompanyData.company_type == 'account_holder'"
                                :disabled="!canEditInputs"
                                type="text" 
                                key_ref="first_name"
                                :value="localCompanyData?.first_name.new_value != undefined ? localCompanyData?.first_name.new_value : localCompanyData?.first_name.value" 
                                @inputChange="inputChangeFunc"
                                label="First Name"/>

                            <InpComponent
                                v-if="localCompanyData.company_type == 'account_holder'"
                                :disabled="!canEditInputs"
                                type="text" 
                                key_ref="last_name"
                                :value="localCompanyData?.last_name.new_value != undefined ? localCompanyData?.last_name.new_value : localCompanyData?.last_name.value" 
                                @inputChange="inputChangeFunc"
                                label="Last Name"/>
                            <InpComponent
                                v-if="localCompanyData.company_type == 'corporate'"
                                :disabled="!canEditInputs"
                                type="text" 
                                key_ref="name"
                                :value="localCompanyData?.name.new_value != undefined ? localCompanyData?.name.new_value : localCompanyData?.name.value" 
                                @inputChange="inputChangeFunc"
                                label="Name"/>

                            <InpComponent
                                v-if="localCompanyData.company_type == 'corporate'"
                                :disabled="!canEditInputs"
                                type="text" 
                                key_ref="chamber_of_commerce"
                                :value="localCompanyData?.chamber_of_commerce.new_value != undefined ? localCompanyData?.chamber_of_commerce.new_value : localCompanyData?.chamber_of_commerce.value" 
                                @inputChange="inputChangeFunc"
                                label="Chamber of Commerce"/>
                            <InpComponent
                                v-if="localCompanyData.company_type == 'corporate'"
                                :disabled="!canEditInputs"
                                type="text" 
                                key_ref="activity"
                                :value="localCompanyData?.activity.new_value != undefined ? localCompanyData?.activity.new_value : localCompanyData?.activity.value" 
                                @inputChange="inputChangeFunc"
                                label="Activity"
                            />
                            <InpComponent
                                v-if="localCompanyData.company_type == 'corporate'"
                                label="Address Line 1"
                                type="text"
                                placeholder="123 Main St"
                                :key_ref="'address_line_1'"
                                :value="localCompanyData.address_line_1.value"
                                :error="localCompanyData.address_line_1.error"
                                @inputChange="inputChangeFunc"
                            />
                            <InpComponent
                                v-if="localCompanyData.company_type == 'corporate'"
                                label="Address Line 2 (optional)"
                                type="text"
                                placeholder=""
                                :key_ref="'address_line_2'"
                                :value="localCompanyData.address_line_2.value"
                                :error="localCompanyData.address_line_2.error"
                                @inputChange="inputChangeFunc"
                            />
                            <InpComponent
                                v-if="localCompanyData.company_type == 'corporate'"
                                label="City / Town"
                                type="text"
                                placeholder="London"
                                :key_ref="'city'"
                                :value="localCompanyData.city.value"
                                :error="localCompanyData.city.error"
                                @inputChange="inputChangeFunc"
                            />
                            <InpComponent
                                v-if="localCompanyData.company_type == 'corporate'"
                                class="country-select"
                                label="Country"
                                type="options"
                                :options="Utils && Utils.getCountryList()"
                                placeholder="Canada"
                                :key_ref="'address_country'"
                                :value="localCompanyData.address_country.value"
                                :error="localCompanyData.address_country.error"
                                @inputChange="inputChangeFunc"
                            />
                            <InpComponent
                                v-if="localCompanyData.company_type == 'corporate'"
                                label="Zip"
                                type="text"
                                placeholder="00000"
                                :key_ref="'zip'"
                                :value="localCompanyData.zip.value"
                                :error="localCompanyData.zip.error"
                                @inputChange="inputChangeFunc"
                            />
                        </div>
                    </div>
                </div>

               


            </div>
            <div class="flex column gap-30 flex-1 h-content">
                

                <div class="section inner-section flex-1 kyc-review-date border-rounded-gray">
                    <h3>Kyc Review</h3>
                    <div class="flex column">
                        <InpComponent
                            :disabled="!canEditInputs"
                            type="date" 
                            
                            label="Date previous compliance review"
                            key_ref="previous_review_date"
                            :value="localCompanyData?.previous_review_date.new_value || localCompanyData?.previous_review_date.value" 
                            @inputChange="inputChangeFunc"
                        />
                        <InpComponent
                            :disabled="!canEditInputs || currentNextReviewMode == 'automatic'"
                            type="date"  
                            :key="`next_review_date_input`"
                            :label="`Date proposed compliance review ${currentNextReviewMode != 'manual' ? '(calculated automatically)' : ''}`"
                            key_ref="next_review_date"
                            :value="localCompanyData?.next_review_date.new_value || localCompanyData?.next_review_date.value" 
                            @inputChange="inputChangeFunc"
                        />
                        <div v-if="!reviewMode" @click="changeReviewDateCalculation()" class="add-section flex align-center w-content">
                            <img class='flip' src="@/assets/flip.svg"> 
                            <text v-if="currentNextReviewMode == 'automatic'">
                                Set Review date manually
                            </text>
                            <text v-else>
                                Set Review date automatically
                            </text>
                        </div>
                        <InpComponent
                            :disabled="!canEditInputs"
                            type="date" 
                            
                            label="Date final compliance review"
                            key_ref="date_final_compliance_review"
                            :value="localCompanyData?.date_final_compliance_review.new_value || localCompanyData?.date_final_compliance_review.value" 
                            @inputChange="inputChangeFunc"
                        />
                    </div>
                </div>
                

                <div v-if="localCompanyData.company_type !== 'account_holder'" class="section inner-section flex-1 border-rounded-gray">
                        <h3 class="">Annual Accounts</h3>
                        <div class="flex column">

                            <Toggle
                                class="mb-15"
                                :disabled="!canEditInputs"
                                :value="getValue('annual_account_conform_calendar_year')"
                                :options="[
                                    { label: 'Yes', value: 'YES' },
                                    { label: 'No', value: 'NO' },
                                ]"
                                @change="(val) => {
                                    handleChange('annual_account_conform_calendar_year', val)
                                }"
                                label="Annual accounts confirm calendar year"
                            />
                            <InpComponent
                                :disabled="!canEditInputs"
                                type="options"
                                :options="yearOptions"  
                                label="Current fiscal year"
                                key_ref="current_fiscal_year"
                                :value="localCompanyData?.current_fiscal_year.new_value || localCompanyData?.current_fiscal_year.value" 
                                @inputChange="inputChangeFunc"
                            />
                            <InpComponent
                                :disabled="!canEditInputs"
                                v-if="(localCompanyData?.annual_account_conform_calendar_year.new_value || localCompanyData?.annual_account_conform_calendar_year.value) == 'NO'"
                                type="date"
                                label="Fiscal Year runs from"
                                key_ref="fiscal_year_starts_on"
                                :value="localCompanyData?.fiscal_year_starts_on.new_value || localCompanyData?.fiscal_year_starts_on.value" 
                                @inputChange="inputChangeFunc"
                            />
                            <InpComponent
                                :disabled="!canEditInputs"
                                v-if="(localCompanyData?.annual_account_conform_calendar_year.new_value || localCompanyData?.annual_account_conform_calendar_year.value) == 'NO'"
                                type="date"
                                label="Fiscal Year runs up till"
                                key_ref="fiscal_year_ending_on"
                                :value="localCompanyData?.fiscal_year_ending_on.new_value || localCompanyData?.fiscal_year_ending_on.value" 
                                @inputChange="inputChangeFunc"
                            />
                            <InpComponent
                                :disabled="!canEditInputs"
                                type="options"
                                :options="yearOptions"  
                                label="Last Annual Accounts on file"
                                key_ref="last_annual_account_on_file"
                                :value="localCompanyData?.last_annual_account_on_file.new_value || localCompanyData?.last_annual_account_on_file.value" 
                                @inputChange="inputChangeFunc"
                            />
                            <InpComponent
                                :disabled="!canEditInputs"
                                type="date"
                                label="Last General Meeting of Shareholders"
                                key_ref="last_board_meeting"
                                :value="localCompanyData?.last_board_meeting.new_value || localCompanyData?.last_board_meeting.value" 
                                @inputChange="inputChangeFunc"
                            />
                    </div>
                </div>
            </div>
            <div class="flex column gap-30 flex-1 h-content">
                <div v-if="localCompanyData.company_type !== 'account_holder'" class="section inner-section flex-1 border-rounded-gray">
                    <h3>Profit Tax</h3>
                    <div class="flex column">
                        <InpComponent
                            :disabled="!canEditInputs"
                            type="options"
                            :options="yearOptions"                               
                            label="Last filed Profit Tax on file "
                            key_ref="last_filed_profit_tax_on_file"
                            :value="localCompanyData?.last_filed_profit_tax_on_file.new_balue || localCompanyData?.last_filed_profit_tax_on_file.value" 
                            @inputChange="inputChangeFunc"
                        />


                        <Toggle
                            :class="getValue('extension_profit_tax') == 'YES' ? 'mb-15' : ''"
                            :disabled="!canEditInputs"
                            :value="getValue('extension_profit_tax')"
                            :options="[
                                { label: 'Yes', value: 'YES' },
                                { label: 'No', value: 'NO' },
                            ]"
                            @change="(val) => handleChange('extension_profit_tax', val)"
                            label="Extension Profit Tax"
                        />


                        <InpComponent
                            :disabled="!canEditInputs"
                            v-if="(localCompanyData?.extension_profit_tax.new_value || localCompanyData?.extension_profit_tax.value) == 'YES'"
                            type="date"
                            
                            label="Extension up till"
                            key_ref="extension_up_till"
                            :value="localCompanyData?.extension_up_till.new_value || localCompanyData?.extension_up_till.value" 
                            @inputChange="inputChangeFunc"
                        />
                    </div>
                </div>
                <div class="section inner-section flex-1 border-rounded-gray">
                    <h3>Compliance settings</h3>
                    <div class="flex column gap-30">
                        <Toggle
                            class="width-240"
                            :disabled="!canEditInputs"
                            :value="getValue('risk_level')"
                            :options="[
                                { label: 'Low', value: 'low' },
                                { label: 'Medium', value: 'medium' },
                                { label: 'High', value: 'high' },
                            ]"
                            @change="(val) => handleChange('risk_level', val)"
                            label="Risk Classification"
                        />
                        <Toggle
                            :disabled="!canEditInputs"
                            :value="getValue('sanction_screening_available')"
                            :options="[
                                { label: 'Yes', value: 'YES' },
                                { label: 'No', value: 'NO' },
                            ]"
                            @change="(val) => handleChange('sanction_screening_available', val)"
                            label="Allow sanction screaning via third party API"
                        />
                        <Toggle
                            class="mb-15"
                            :disabled="!canEditInputs"
                            :value="getValue('transaction_profile_report')"
                            :options="[
                                { label: 'Yes', value: 'YES' },
                                { label: 'No', value: 'NO' },
                            ]"
                            @change="(val) => handleChange('transaction_profile_report', val)"
                            label="Transaction Profile Present"
                        />

                    </div>
                </div>
            </div>
            
        </div>
        <PopupCover v-if="reportSave">
            <LoaderPopup />
        </PopupCover>

        <PopupCover v-if="showPopups" @close="showPopups = false">
            <SnapshotPopup 
                @close="showPopups = false" 
                :companySelector="false"
                @InfoUpdate="createObjectPopupHandler"
            />
        </PopupCover>
    </div>

</template>

<script setup>

import InpComponent from '@/components/InpComponent.vue'
import { PermissionChecker } from '@/utils/iam_utils'
import Utils from '@/utils/index.js'
import { ref, defineEmits, onMounted, computed } from 'vue' 
import LoaderPopup from '@/components/LoaderPopup.vue'
import SnapshotPopup from '@/components/SnapshotPopup.vue'
import PopupCover from '@/components/PopupCover.vue'
import Toggle from '@/elements/Toggle.vue'
import ChartComponent from '@/components/ChartComponent.vue'

import API from '@/api/index.js'
import store from '@/store'

const emit = defineEmits(['changeCompanyData'])

const yearOptions = computed(() => store.state.yearOptions);
const reportSave = ref(false);
const showPopups = ref(false);

const props = defineProps(['companyData', 'yearLabel', 'reviewMode']);
const localCompanyData = computed(() => store.state.companyData);
const canEditInputs = computed(() => PermissionChecker.updateDashboardSection() && !props.reviewMode)
const user = computed(() => store.state.user)
const accountNumbers = computed(() => store.state.kyc_accountNumbers)

const companyData = computed(() => store.state.companyData);


const currentNextReviewMode = computed(() => {
    return localCompanyData.value.next_review_date_type.new_value || localCompanyData.value.next_review_date_type.value;
})
const getLabel = computed(() => {
    const labelsDict = {
        'bank': 'Account Number',
        'credit_union': 'Account Number',
        'pention': 'Pension Number',
        'insurance': 'Policy Number',
        'player': 'Player ID'
    }
    return labelsDict[localCompanyData.value.account_holder_type] || 'Account Holder Number'
})


const showDisclaimer = computed(() => {
    if(!companyData.value) return false;
    
    const corporate = {
        'name': 'Name',
        'risk_level': 'Risk level',
        'previous_review_date': 'Date previous compliance review',
        'next_review_date' : 'Date proposed compliance review',
        'date_final_compliance_review': 'Date final compliance review',
        'extension_profit_tax': 'Extension profit tax',
        'current_fiscal_year': 'Current fiscal year',
        'last_annual_account_on_file': 'Last annual account on file',
        'last_filed_profit_tax_on_file': 'Last filed profit tax on file',
    }

    const accountHolderFields = {
        'first_name': 'First_name',
        'last_name': 'Last name',
        'risk_level': 'Risk level',
        'previous_review_date': 'Previous review date',
        'next_review_date' : 'Next review date',
        'date_final_compliance_review': 'Date final compliance review',
    }
    let fileds = null;
    let requirements = []

    if(companyData.value.company_type === 'corporate') {
        fileds = corporate;
    }

    if(companyData.value.company_type === 'account_holder') {
        fileds = accountHolderFields;
    } 
    for (let key in fileds) {
        if (!companyData.value[key].value) {
            requirements.push(fileds[key])
        } else if (key == 'extension_profit_tax' && companyData.value[key].value === 'YES' && !companyData.value['extension_up_till'].value) {
            requirements.push('Extension up till')
        }
    }
    if ( companyData.value.location_type.value === 'abroad' &&
        !companyData.value.last_board_meeting.value
    ) {
        requirements.push('Last general meeting of shareholders')
    }
    return requirements
});


async function createObjectPopupHandler(event) {
    showPopups.value = false;
    reportSave.value = true;
    await API.completeReport({company_id: localCompanyData.value._id, ...event.object})
    reportSave.value = false;
}


async function verifyReport(object){
    showPopups.value = true;
}


const getValue = computed(() => (field) => {
    if (localCompanyData.value[field].new_value) {
        return localCompanyData.value[field].new_value;
    } else {
        return localCompanyData.value[field].value;
    }
})


const locationType = computed(() => {
    if (localCompanyData.value.location_type.new_value) {
        return localCompanyData.value.location_type.new_value;
    } else {
        return localCompanyData.value.location_type.value;
    }
})

function inputChangeFunc(event) {
    const event_type = event[0];
    const event_value = event[1];
    const parts = event_type.split('|');
    if (parts.length > 1 && parts[0] === 'account_number') {
        store.commit('updateAccountNumberById', {
            id: parts[1], 
            updates: {
                account_number: event_value
            }
        })
        return;
    }
    store.commit('updateKycReviewInfo', {
        id: localCompanyData.value._id, 
        updates: {
            [event_type]: event_value
        }
    })
    if (event_type == 'previous_review_date' && currentNextReviewMode.value == 'automatic') {
        let new_date = getNextReviewDate();
        if (new_date) {
            store.commit('updateKycReviewInfo', {
                id: localCompanyData.value._id, 
                updates: {
                    next_review_date: new_date
                }
            })
        }
    }
}


function getNextReviewDate(){
    let prevDate = localCompanyData.value.previous_review_date.new_value || localCompanyData.value.previous_review_date.value; 
    if (!prevDate) {
        return;
    }
    let current_risk_level = localCompanyData.value.risk_level.new_value || localCompanyData.value.risk_level.value;
    let next_review_date_map = {
        'low': 3,
        'medium': 2,
        'high': 1
    };
    let nextDate = new Date(prevDate);
    nextDate.setFullYear(nextDate.getFullYear() + next_review_date_map[current_risk_level]);
    store.commit('updateKycReviewInfo', {
        id: localCompanyData.value._id, 
        updates: {
            next_review_date: nextDate.toISOString().split('T')[0]
        }
    })
}


function changeReviewDateCalculation(){
    const new_value = currentNextReviewMode.value == 'automatic' ? 'manual' : 'automatic'; 
    store.commit('updateKycReviewInfo', {
        id: localCompanyData.value._id, 
        updates: {
            next_review_date_type: new_value
        }
    })
    if (new_value == 'automatic') {
        getNextReviewDate();
    }
}

function handleChange(field, event) {
    store.commit('updateKycReviewInfo', {
        id: localCompanyData.value._id, 
        updates: {
            [field]: event
        }
    })
    if (field == 'risk_level' && currentNextReviewMode.value == 'automatic') {
        getNextReviewDate();
    }
}

function addAccountNumber(){
    store.dispatch('addAccountNumber', {
        id: localCompanyData.value._id
    })
}

onMounted(() => {
    const fields = [
        'sanction_screening_available',
        'risk_level',
        'extension_profit_tax',
        'annual_account_conform_calendar_year',
        'sanction_screening_available',
        'transaction_profile_report',
    ];
    for (let field of fields) {
        if (localCompanyData.value[field].value) {
            const element_id = `${localCompanyData.value[field].value}-${field}`;
            let element = document.getElementById(`${element_id}`);
            if (element) {
                element.checked = true;
            }
       }
    }
})

</script>

<style lang="scss" scoped>
    .add-section {
        text-align: right;
        color: var(--primary-color);
        font-size: 12px;
        margin-top: -12px;
        margin-bottom: 12px;
        justify-content: flex-end;
        gap: 5px;
        margin-left: auto;
        cursor: pointer;
    }
    .table-users {
        width: 100%;
        border-collapse: collapse;
        border-bottom: 1px solid #e6eaed;
    }
    .header {
        margin-bottom: 0;
    }
    .risk-section {
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .section {
        background: white;
        padding: 20px;
        border-radius: 5px;
        box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
        border: 1px solid var(--border-color);
        box-sizing: border-box;
    }
    .sections {
        padding-top: 10px;
    }
    .kyc-fields-area {
        // border: 1px solid #e0e0e0;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: baseline;
        // background-color: white;
        box-sizing: border-box;

        border-radius: 5px;
        color: black;
    }
    .flip {
        height: 15px;
    }
    h3 {
        text-align: left;
    }

    td {
        padding: 10px 30px;
        text-align: left;
    }
    th {
        text-align: left;
        padding: 10px 30px;
        background: #F3F5F6;
    }

    .address[class] {
        max-width: unset;
        
    }
    .border-rounded-gray {
        border: 1px solid var(--border-color);
        h3 {
            text-align: left;
            margin-top: 0;
        }
    }
    .chart-area {
        padding-bottom: 20px;
    }
    .seciont-info {
        background-color: white;
        padding: 20px;
        border: 1px solid var(--border-color);
        border-radius: 5px;
    }
    .bg-white {
        background-color: white;
        border: 1px solid var(--border-color);
        border-radius: 5px;
        box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
        min-height: 100px;
    }
    .width-240[class]{
        &:deep(.toggle){
            width: 240px;
        }
    }
    .disclaimer {
        box-shadow: 0px 0px 1.5px 0px #BB3530;
        padding: 20px;
        width: 100%;
        border-radius: 5px;
        display: flex;
        box-sizing: border-box;
        flex-direction: column;
        align-items: flex-start;
        background-color: #FEF4F5;
    }
    .req-warning {
        color: #BB3530;
        font-size: 24px;
        font-weight: 600;
        display: flex;
        align-items: center;
        img {
            margin-right: 20px;
        }
    }
    .warning-point {
        color: #BB3530;
        padding-left: 40px;
        font-size: 14px;
        font-weight: 500;
        margin-left: 25px;
        position: relative;
        text-align: left;
        &::before {
            content: '';
            position: absolute;
            left: 25px;
            top: 8px;
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background: #BB3530;
        }
    }
    .disclaimer-text {
        padding-top: 3px;
        font-size: 14px;
        font-weight: 500;
    }
</style>